<template>
  <footer class="packages-overview-filters-footer">
    <Button class="packages-overview-filters-footer__button"
            @click="$emit('closeFilters')"
    >

      <template v-if="!loadingResults">
        Toon {{ amount }} {{ amount === 1 ? 'resultaat' : 'resultaten' }}
      </template>

      <InlineSvg v-else
                 src="@/assets/images/icons/loading.svg"
                 class="packages-overview-filters-footer__button-icon"
                 />

    </Button>
  </footer>
</template>

<script>
import Button from '@/components/UI/Button.vue';
import InlineSvg from '@/components/UI/InlineSvg.vue';

export default {
  name: 'FiltersFooter',

  components: {
    Button,
    InlineSvg,
  },

  props: {
    amount: {
      type: Number,
      required: true,
    },
    loadingResults: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/css/helpers/mixins/breakpoints';

  .packages-overview-filters-footer {
    padding: var(--spacing-m);

    @include laptop-and-larger {
      display: none;
    }

    &__button {
      width: 100%;

      &-icon {
        height: 1em;
        animation: spin 1s linear infinite;
      }
    }
  }
</style>
